import { useCallback, useState } from 'react';
import { PORTAL } from 'src/ReduxStorage/resourceNames';
import {
  PortalResource,
  PortalResourceInviteMembers,
} from 'src/resource/PortalResource/types';
import { ResourceApi } from 'src/resource/Resource';

export const useInviteMembersApi = (
  institutionPath: string
): {
  inviteMembers: (
    params: PortalResourceInviteMembers['args']
  ) => Promise<unknown>;
  error: string;
  isLoading: boolean;
} => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  const inviteMembers = useCallback(
    (params: PortalResourceInviteMembers['args']) => {
      setIsLoading(true);
      return ResourceApi.update<PortalResource, PortalResourceInviteMembers>(
        PORTAL,
        institutionPath,
        'inviteMembers',
        params
      )
        .then(() => setError(''))
        .catch((err) => {
          setError(err?.response?.reason ?? err.message);
          throw err;
        })
        .finally(() => setIsLoading(false));
    },
    [institutionPath]
  );

  return { inviteMembers, error, isLoading };
};
